import { motion } from "framer-motion";
import styled from "styled-components";
import BackgroundImage from "../../assets/Images/Background/BackgroundImage.svg"

interface BackdropProps {
  children: React.ReactNode;
  onClick?: () => void;
}

const Backdrop = ({ children, onClick }: BackdropProps) => {
  return (
    <BackdropStyled
      onClick={() => {}}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </BackdropStyled>
  );
};

export default Backdrop;

// background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${BackgroundImage});
const BackdropStyled = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  // background-image: url(${BackgroundImage});
  background: #000000e1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;